import {StyleSheet, Text, View} from "@react-pdf/renderer";
import React from "react";

const WATERMARK_ROWS = 4;
const WATERMARK_COLUMNS = 3;

const styles = StyleSheet.create({
    watermarkContainer: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 12,
    },
    watermarkText: {
        position: 'absolute',
        fontSize: 48,
        color: '#000000',
        transform: 'rotate(-45deg)',
        opacity: 0.2,
    },
});

function PdfWaterMark(props: { text: string }) {
    const positions = generatePositions(WATERMARK_ROWS, WATERMARK_COLUMNS);
    return (
        <View style={styles.watermarkContainer}>
            {positions.map((pos, index) => (
                <Text key={index} style={{...styles.watermarkText, ...pos}}>
                    {props.text}
                </Text>
            ))}
        </View>
    );
}

function generatePositions(rows: number, cols: number) {
    return Array.from({length: rows * cols}, (_, i) => ({
        top: `${5 + Math.floor(i / cols) * (95 / (rows - 1))}%`,
        left: `${(i % cols) * (100 / (cols))}%`
    }));
}

export default PdfWaterMark;